<template>
    <v-container >
        <v-card>
            <v-toolbar dense dark elevation="0">
                <v-toolbar-title>Last SNe confirmed</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <TableTNS :confirmed="confirmed"></TableTNS>
            <FooterTNS></FooterTNS>
        </v-card>
    </v-container>
</template>
<script>
import TableTNS from "@/components/tables/TableTNS.vue"
import FooterTNS from "@/components/misc/FooterTNS.vue"
export default {
    name: "TNSConfirmed",
    components: {
        TableTNS,
        FooterTNS
    },
    data(){
        return {
            confirmed: []
        }
    },
    mounted() {
        this.getData("ALeRCE");
    },
    methods: {
        getData(broker){
            this.$tnsapi.get_last_sne_confirmed(broker).then(response => {
                this.confirmed = response.data;
            });
        },
    }
}
</script>